import { useContext, useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Steps } from 'antd';
import './studyPage.css'; // Import your CSS file
import { Typography } from '@mui/material';
import axios from 'axios';
import { Link } from 'react-router-dom';
import UserContext from '../../Context/User/userContext';

const StudyCard = ({ setShowSpinner, id }) => {
  const [data, setData] = useState([]);
  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";
  const getData = () => {
    setShowSpinner(true);
    if (id) {
      axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`,
        {
          _id: id
        }, {
        headers: {
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
        .then(res => {
          const response = res.data.data
          setData(response);
        })
        .catch(error => {
          console.log(error.response?.data?.message);
        })
        .finally(() => {
          setShowSpinner(false);
        })
    } else {
      axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`,
        {
          status: 'active'
        }, {
        headers: {
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
        .then(res => {
          const response = res.data.data
          setData(response);
        })
        .catch(error => {
          console.log(error.response?.data?.message);
        })
        .finally(() => {
          setShowSpinner(false);
        })
    }
  }

  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    if (user) {
      getData()
    }
  }, [user])
  return (
    <>
      <div className='p-2'>
      <h4 style={{color:'rgb(23 131 131)'}}>Active Studies</h4>
        <div >
          {
            data.length === 0 ?
            <div className='d-flex justify-content-center align-items-center'>
                <img width={500} height={500} src={require('../../images/nodataImg.webp')} alt="No Data Available" />
                </div>
              :
              data.map((v, i) => (
                <Card className='mt-3' key={v._id}>
                  <Card.Body>
                    <Row>
                      <Col>
                        <h6>Study Code</h6>
                        <Link style={{ textDecoration: "none" }} to={`/activeStudyForm/${v._id}`}>
                          <p>{v.studyCode}</p>
                        </Link>
                      </Col>
                      <Col>
                        <h6>Study Title</h6>
                        <p>{v.title}</p>
                      </Col>
                      <Col>
                        <h6>Sponsor/CRO</h6>
                        <p>{v.sponsorName}/{v.CRO}</p>
                      </Col>
                      <Col>
                        <h6>Active Date</h6>
                        <p>{v.activationDate}</p>
                      </Col>
                      <Col>
                        <h6>Study Manager</h6>
                        <p>{v.manager}</p>
                      </Col>
                      <Col>
                        <h6>Status</h6>
                        <p>{v.status}</p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))
          }
        </div>
      </div>
    </>
  );
};

export default StudyCard;
